import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useGetStep } from 'shared/hooks'
import { StepsCommonLayout } from 'pages/settings/ui/StepsCommonLayout/StepsCommonLayout'
import { useProgressInfoTitle } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/AddNumberFromApp/hooks/useProgressInfoTitle'
import {
  AddNumberFromAppProvider,
  useAddNumberFromAppContext,
} from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/AddNumberFromApp/context/useAddNumberFromAppContext'
import { type AddNumberFromAppRoutes } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/AddNumberFromApp/store/addNumberFromAppStore'

const AddNumberFromAppLayoutContent = observer(() => {
  const { allStepsLength, decreaseStep, setCurrentStep, getSettingsStep, redirectToNumbers } =
    useAddNumberFromAppContext()
  const settingsStep = useGetStep<AddNumberFromAppRoutes>(getSettingsStep)
  const infoTitle = useProgressInfoTitle()

  useEffect(() => {
    setCurrentStep(settingsStep)
  }, [settingsStep, setCurrentStep])

  return (
    <StepsCommonLayout
      progressTitle={infoTitle}
      totalSteps={allStepsLength}
      title='Add number from app'
      settingsStep={settingsStep}
      closeSetting={redirectToNumbers}
      decreaseStep={decreaseStep}
    />
  )
})

export const AddNumberFromAppLayout = () => {
  return (
    <AddNumberFromAppProvider>
      <AddNumberFromAppLayoutContent />
    </AddNumberFromAppProvider>
  )
}
